"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SaleType;
(function (SaleType) {
    SaleType["Sale"] = "sale";
    SaleType["Rent"] = "rent";
})(SaleType = exports.SaleType || (exports.SaleType = {}));
